var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"d-flex align-items-center py-2 px-3",class:_vm.badgeClass,attrs:{"pill":""}},[_c('span',{staticClass:"d-inline-block rounded-circle mr-1",class:_vm.dotClass,staticStyle:{"width":"8px","height":"8px"}}),_c('span',{staticClass:"small"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }